import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { useResize } from 'hooks/common';
type Props = {
  count?: number;
};
const SubscriptionCardSkeleton = ({ count = 1 }: Props) => {
  const NO_OF_ITEMS_ARRAY: number[] = [];

  for (let i = 1; i <= count; i++) {
    NO_OF_ITEMS_ARRAY.push(i);
  }
  const { isMobile } = useResize();

  return (
    <>
      {NO_OF_ITEMS_ARRAY.map((item) => (
        <Box
          sx={{
            border: '1px solid #888',
            borderRadius: '15px',
            width: isMobile ? '100%' : `${95 / 4}%`,
            position: 'relative',
          }}
          key={item}
        >
          <Box
            paddingY={2}
            paddingX={3.5}
            display='flex'
            flexDirection='column'
            gap={2}
          >
            <Skeleton variant='text' width='60%' height={30} />
            <Skeleton variant='text' width='80%' height={20} />
            <Skeleton variant='rectangular' width='100%' height={40} />
            <Skeleton variant='rectangular' width='100%' height={50} />
            <Skeleton variant='rectangular' width='100%' height={50} />
            <Skeleton variant='rectangular' width='100%' height={300} />
          </Box>
        </Box>
      ))}
    </>
  );
};

export default SubscriptionCardSkeleton;
